

//
// Ensure that the ws object exists
//
if(!window.ws) window.ws = {};

// Require common utils
require('../../../../common/assets/js/utils/_utils');

require('./FFSaveLogin');